import React, { useContext, useState } from "react";
import "./Dashboard_sidebar.css";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";
import { Modal, Button } from "react-bootstrap";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MENU_BY_ROLE = {
  student: [
    {
      id: IDS.Permission.StudentDashboard.List,
      label: "Dashboard",
      icon: "/assets/images/icon/dashboard.webp",
    },
    {
      id: IDS.Permission.StudentApplications.List,
      label: "Applications",
      icon: "/assets/images/icon/detail_doc.webp",
    },
    {
      id: IDS.Permission.StudentDocuments.List,
      label: "Documents",
      icon: "/assets/images/icon/file_doc.webp",
    },
    {
      id: IDS.Permission.CollegeOffer.List,
      label: "To-Do Task",
      icon: "/assets/images/icon/check_doc.webp",
    },
    {
      id: IDS.Permission.StudentBilling.List,
      label: "Billing",
      icon: "/assets/images/icon/rol-pepp.webp",
    },
    {
      id: IDS.Permission.CollegeOffer.List,
      label: "Language Test",
      icon: "/assets/images/icon/alfa.webp",
    },
    {
      id: IDS.Permission.StudentSupport.List,
      label: "Support",
      icon: "/assets/images/icon/quetion_tag.webp",
    },
    {
      id: IDS.Permission.StudentProfile.List,
      label: "Profile",
      icon: "/assets/images/icon/profile.webp",
    },
  ],

  college: [
    {
      id: IDS.Permission.CollegeDashboard.List,
      label: "Dashboard",
      icon: "/assets/images/icon/dashboard.webp",
    },
    {
      id: IDS.Permission.CollegeIntern.List,
      label: "Intern",
      icon: "/assets/images/icon/detail_doc.webp",
    },

    {
      id: IDS.Permission.CollegeOffer.List,
      label: "Offer",
      icon: "/assets/images/icon/open_file.webp",
    },
    {
      id: IDS.Permission.CollegeIntern.List,
      label: "Global Map",
      icon: "/assets/images/icon/globe_degree.webp",
    },
    {
      id: IDS.Permission.CollegeDocuments.List,
      label: "Documents",
      icon: "/assets/images/icon/file_doc.webp",
    },
    {
      id: IDS.Permission.CollegeProfile.List,
      label: "Profile",
      icon: "/assets/images/icon/profile.webp",
    },
  ],

  hotel: [
    {
      id: IDS.Permission.HotelDashboard.List,
      label: "Dashboard",
      icon: "/assets/images/icon/dashboard.webp",
    },
    {
      id: IDS.Permission.HotelIntern.List,
      label: "Intern",
      icon: "/assets/images/icon/detail_doc.webp",
    },
    {
      id: IDS.Permission.HotelDocuments.List,
      label: "Global Map",
      icon: "/assets/images/icon/globe_degree.webp",
    },
    {
      id: IDS.Permission.HotelDocuments.List,
      label: "Documents",
      icon: "/assets/images/icon/file_doc.webp",
    },
    {
      id: IDS.Permission.HotelProfile.List,
      label: "Profile",
      icon: "/assets/images/icon/profile.webp",
    },
  ],

  admin: [
    {
      id: IDS.Permission.AdminDashboard.List,
      label: "Dashboard",
      icon: "/assets/images/icon/dashboard.webp",
    },
    // { label: "Profile", icon: "/assets/images/icon/profile.webp" },
  ],
};

const MASTER_MENU = [
  {
    id: IDS.Permission.Country.List,
    label: "Country",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.State.List,
    label: "State",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.City.List,
    label: "City",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Pincode.List,
    label: "Pincode",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Faq.List,
    label: "Faq",
    icon: "/assets/images/icon/file_doc.webp",
  },

  {
    id: IDS.Permission.StudentDocument.List,
    label: "Student Documents",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const USER_MENU = [
  {
    id: IDS.Permission.Roles.List,
    label: "Role",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.StudentList.List,
    label: "Student",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.CollegeList.List,
    label: "College",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.HotelList.List,
    label: "Hotel",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const COURSE_MENU = [
  {
    id: IDS.Permission.Program_Highlight.List,
    label: "Program Highlight",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Eligibility_Requirement.List,
    label: "Eligibility Requirement",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Career_Requirement.List,
    label: "Career Requirement",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Requirement_Documents.List,
    label: "Requirement Documents",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Accomodation.List,
    label: "Accomodation",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.University.List,
    label: "University",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Course.List,
    label: "Course",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Study_Program.List,
    label: "Study Program",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const INTERNSHIP_MENU = [
  {
    id: IDS.Permission.Document.List,
    label: "Document",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Requirement.List,
    label: "Requirement",
    icon: "/assets/images/icon/file_doc.webp",
  },
  {
    id: IDS.Permission.Internship.List,
    label: "Internship",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const SUPPORT_MENU = [
  {
    id: IDS.Permission.Ticket.List,
    label: "Document",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const ADMIN_CONTACT_US = [
  {
    id: IDS.Permission.AdminContactUs.List,
    label: "Contact Us",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const ADMIN_NEED_ADVICE = [
  {
    id: IDS.Permission.AdminNeedAdvice.List,
    label: "Need Advice",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const WEBSITE_MENU_HOME = [
  // {
  //   id: IDS?.Permission?.WebsiteHomeWhychooseUS?.List,
  //   label: "Why Choose Us",
  //   icon: "/assets/images/icon/file_doc.webp",
  // },
  // {
  //   id: IDS?.Permission?.WebsiteHomeWhoWeAre?.List,
  //   label: "Who We Are",
  //   icon: "/assets/images/icon/file_doc.webp",
  // },
  {
    id: IDS?.Permission?.WebsiteHomeSuccessSpeaks?.List,
    label: "Success Speaks",
    icon: "/assets/images/icon/file_doc.webp",
  },

  {
    id: IDS?.Permission?.WebsiteHomeFAQ?.List,
    label: "Home FAQ",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const WEBSITE_MENU_ABOUTUS = [
  {
    id: IDS?.Permission?.WebsiteAboutUsOurStory?.List,
    label: "Our Story",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const WEBSITE_MENU_CONTACTUS = [
  {
    id: IDS?.Permission?.WebsiteContactUsGetInTouch?.List,
    label: "Get In Touch",
    icon: "/assets/images/icon/file_doc.webp",
  },
];

const ROUTES = {
  // Student
  83: "/portal/student/dashboard",
  84: "/portal/student/applications",
  85: "/portal/student/documents",
  "To-Do Task": "/portal/student/todo-task",
  86: "/portal/student/billing-manegment",
  "Language Test": "/portal/student/language-test",
  87: "/portal/student/support",
  88: "/portal/student/profile",

  // College
  74: "/portal/college/college-dashboard",
  75: "/portal/college/college-intern",
  76: "/portal/college/college-offer",
  "Global Map": "/portal/college/college-global-map",
  77: "/portal/college/college-document",
  78: "/portal/college/college-profile",

  // Hotel
  79: "/portal/hotel/hotel-dashboard",
  80: "/portal/hotel/hotel-intern",
  81: "/portal/hotel/hotel-document",
  82: "/portal/hotel/hotel-profile",

  // Admin
  119: "/portal/admin/admin-dashboard",
  9: "/portal/admin/admin-country",
  13: "/portal/admin/admin-state",
  17: "/portal/admin/admin-city",
  21: "/portal/admin/admin-pincode",
  37: "/portal/admin/admin-faq",
  111: "/portal/admin/admin-student-document",
  1: "/portal/admin/admin-role",
  108: "/portal/admin/admin-student",
  109: "/portal/admin/admin-college",
  110: "/portal/admin/admin-hotel",
  50: "/portal/admin/admin-programhighlight",
  54: "/portal/admin/admin-eligibilityrequirement",
  58: "/portal/admin/admin-careerrequirement",
  62: "/portal/admin/admin-requirementdocument",
  66: "/portal/admin/admin-document",
  70: "/portal/admin/admin-requirement",
  25: "/portal/admin/admin-university",
  89: "/portal/admin/admin-course",
  93: "/portal/admin/admin-accomodation",
  97: "/portal/college/admin-studyprogram",
  101: "/portal/hotel/admin-internship",
  105: "/portal/admin/admin-support",

  //Conttact Us

  127: "/portal/admin/admin-contactus",
  128: "/portal/admin/admin-need-advice",

  //Website
  //Home
  120: "/portal/admin/admin-website-home-why-choose-us",
  121: "/portal/admin/admin-website-home-who-we-are",
  122: "/portal/admin/admin-website-home-success-speaks",
  123: "/portal/admin/admin-website-home-faq",
  //Aboutus
  124: "/portal/admin/admin-website-aboutus-ourstory",

  //Aboutus
  126: "/portal/admin/admin-website-contactus-getintouch",
};

function Dashboard_sidebar({ collapsed, setCollapsed, role }) {
  const menuItems = MENU_BY_ROLE[role] || [];

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();
  const { setSignin } = useContext(Context);

  const handleLogoutYes = () => {
    Cookies.remove("af_mobility_security");
    setSignin(false);
    setShowLogoutModal(false);
    navigate("/");
  };

  const handleLogoutNo = () => {
    setShowLogoutModal(false);
  };

  const [activeMenu, setActiveMenu] = useState(menuItems[0]?.label);

  // Get permissions from Redux
  // const permissions = useSelector((state) => state.auth?.permissions ?? []);
  const { isAllow } = useContext(Context);

  // const handleMenuClick = (label) => {
  //   setActiveMenu(label);
  //   onMenuSelect(label);
  // };

  const handleMenuClick = (menuId, label) => {
    setActiveMenu(label);

    const route = ROUTES[menuId] || "/portal";
    navigate(route);
  };

  const renderMenuItems = (items) =>
    items.map(
      (item, index) =>
        Array.isArray(isAllow) &&
        isAllow.includes(item.id) && (
          <>
            {/* <li
              key={index}
              className={`menu_item ${
                activeMenu === item.label ? "active" : ""
              }`}
              onClick={() => handleMenuClick(item.id)}
            > */}
            <li
              key={index}
              className={`menu_item ${
                activeMenu === item.label ? "active" : ""
              }`}
              onClick={() => handleMenuClick(item.id, item.label)}
            >
              <img src={item.icon} className="icon_img" alt={item.label} />
              {!collapsed && <span className="label">{item.label}</span>}
            </li>
          </>
        ),
    );

  // Helper to check if user has any permission for a module
  // const hasPermission = (ids = []) => {
  //   if (role === "admin") return true;
  //   if (!Array.isArray(permissions)) return false;

  //   return ids.some((id) => permissions.includes(id));
  // };

  const hasPermission = (ids = []) => {
    console.log(ids, "idsids");

    if (role === "admin") return true;
    if (!Array.isArray(isAllow)) return false; // Use isAllow instead of permissions

    return ids.some((id) => isAllow.includes(id));
  };

  const [activeKey, setActiveKey] = useState("0");
  return (
    <section className="Dashboard_sidebar">
      <button className="collapse_btn" onClick={() => setCollapsed(!collapsed)}>
        <FontAwesomeIcon icon={collapsed ? faAngleRight : faAngleLeft} />
      </button>

      <div
        className={`Dashboard_sidebar_parent ${collapsed ? "collapsed" : ""}`}
      >
        <ul className="menu_list">
          {/* Normal Menu (role-based, always visible for the role) */}
          {renderMenuItems(menuItems)}

          <>
            {/* User Management Section */}
            {hasPermission([
              IDS.Permission.Roles.List || IDS.Permission.Users.List,
            ]) && (
              <Accordion
                defaultActiveKey="0"
                className="mt-2"
                activeKey={activeKey}
                onSelect={(eventKey) => setActiveKey(eventKey)}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="menu_item">
                    User Management
                  </Accordion.Header>

                  <Accordion.Body className="p-0">
                    <ul className="menu_list mt-0">
                      {renderMenuItems(USER_MENU)}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}

            {hasPermission([
              IDS.Permission.Country.List ||
                IDS.Permission.State.List ||
                IDS.Permission.City.List ||
                IDS.Permission.Pincode.List ||
                IDS.Permission.Faq.List ||
                IDS.Permission.StudentDocument.List,
            ]) && (
              <Accordion
                defaultActiveKey="1"
                className="mt-2"
                activeKey={activeKey}
                onSelect={(eventKey) => setActiveKey(eventKey)}
              >
                <Accordion.Item eventKey="1">
                  <Accordion.Header className="menu_item">
                    Master
                  </Accordion.Header>

                  <Accordion.Body className="p-0">
                    <ul className="menu_list mt-0">
                      {/* Individual items can also be conditionally rendered if needed */}
                      {renderMenuItems(MASTER_MENU)}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}

            {/* College Program Section */}
            {hasPermission([
              IDS.Permission.Program_Highlight.List ||
                IDS.Permission.Eligibility_Requirement.List ||
                IDS.Permission.Career_Requirement.List ||
                IDS.Permission.Requirement_Documents.List ||
                IDS.Permission.University.List ||
                IDS.Permission.Course.List ||
                IDS.Permission.Study_Program.List,
              // IDS.Permission.CollegeDashboard.List,
              // IDS.Permission.CollegeIntern.List,
              // IDS.Permission.CollegeOffer.List,
              // IDS.Permission.CollegeDocuments.List,
              // IDS.Permission.CollegeProfile.List,
            ]) && (
              <Accordion
                defaultActiveKey="3"
                className="mt-2"
                activeKey={activeKey}
                onSelect={(eventKey) => setActiveKey(eventKey)}
              >
                <Accordion.Item eventKey="3">
                  <Accordion.Header className="menu_item">
                    College Management
                  </Accordion.Header>

                  <Accordion.Body className="p-0">
                    <ul className="menu_list mt-0">
                      {renderMenuItems(COURSE_MENU)}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}

            {/* Hotel Program Section */}
            {hasPermission([
              IDS.Permission.Document.List ||
                IDS.Permission.Requirement.List ||
                IDS.Permission.Internship.List,
            ]) && (
              <Accordion
                defaultActiveKey="4"
                className="mt-2"
                activeKey={activeKey}
                onSelect={(eventKey) => setActiveKey(eventKey)}
              >
                <Accordion.Item eventKey="4">
                  <Accordion.Header className="menu_item">
                    Hotel Management
                  </Accordion.Header>

                  <Accordion.Body className="p-0">
                    <ul className="menu_list mt-0">
                      {renderMenuItems(INTERNSHIP_MENU)}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}

            {hasPermission([IDS.Permission.Document.List]) && (
              <Accordion
                defaultActiveKey="5"
                className="mt-2"
                activeKey={activeKey}
                onSelect={(eventKey) => setActiveKey(eventKey)}
              >
                <Accordion.Item eventKey="5">
                  <Accordion.Header className="menu_item">
                    Ticket Support
                  </Accordion.Header>

                  <Accordion.Body className="p-0">
                    <ul className="menu_list mt-0">
                      {renderMenuItems(SUPPORT_MENU)}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}

            {hasPermission([IDS.Permission.AdminContactUs.List]) && (
              <Accordion
                defaultActiveKey="7"
                className="mt-2"
                activeKey={activeKey}
                onSelect={(eventKey) => setActiveKey(eventKey)}
              >
                <Accordion.Item eventKey="7">
                  <Accordion.Header className="menu_item">
                    Contat Us
                  </Accordion.Header>

                  <Accordion.Body className="p-0">
                    <ul className="menu_list mt-0">
                      {renderMenuItems(ADMIN_CONTACT_US)}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}

            {hasPermission([IDS.Permission.AdminNeedAdvice.List]) && (
              <Accordion
                defaultActiveKey="8"
                className="mt-2"
                activeKey={activeKey}
                onSelect={(eventKey) => setActiveKey(eventKey)}
              >
                <Accordion.Item eventKey="8">
                  <Accordion.Header className="menu_item">
                    Need Advice
                  </Accordion.Header>

                  <Accordion.Body className="p-0">
                    <ul className="menu_list mt-0">
                      {renderMenuItems(ADMIN_NEED_ADVICE)}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}

            {hasPermission([IDS.Permission.AdminDashboard.List]) && (
              <Accordion
                defaultActiveKey="6"
                className="mt-2"
                activeKey={activeKey}
                onSelect={(eventKey) => setActiveKey(eventKey)}
              >
                <Accordion.Item eventKey="6">
                  <Accordion.Header className="menu_item">
                    Website
                  </Accordion.Header>

                  <Accordion.Body className="p-0">
                    {/* <ul className="menu_list mt-0">
                      {renderMenuItems(WEBSITE_MENU)}
                    </ul> */}

                    <Accordion
                      defaultActiveKey="61"
                      className="inner_accordian_holder mt-2"
                    >
                      <Accordion.Item eventKey="61">
                        <Accordion.Header className="menu_item menu_item mb-0">
                          Home
                        </Accordion.Header>

                        <Accordion.Body className="p-0">
                          <ul className="menu_list mt-3">
                            {renderMenuItems(WEBSITE_MENU_HOME)}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    <Accordion
                      defaultActiveKey="62"
                      className="inner_accordian_holder mt-2"
                    >
                      <Accordion.Item eventKey="62">
                        <Accordion.Header className="menu_item mb-0">
                          About Us
                        </Accordion.Header>

                        <Accordion.Body className="p-0">
                          <ul className="menu_list mt-3">
                            {renderMenuItems(WEBSITE_MENU_ABOUTUS)}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    <Accordion
                      defaultActiveKey="63"
                      className="inner_accordian_holder mt-2"
                    >
                      <Accordion.Item eventKey="63">
                        <Accordion.Header className="menu_item mb-0">
                          Contact Us
                        </Accordion.Header>

                        <Accordion.Body className="p-0">
                          <ul className="menu_list mt-3">
                            {renderMenuItems(WEBSITE_MENU_CONTACTUS)}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
          </>
        </ul>

        <hr className="divider" />

        {/* <Link to="/">
          <button className="exit_btn">
            <img
              src="/assets/images/icon/exit.webp"
              className="exit_icon_img"
              alt="Exit"
            />
            {!collapsed && "Exit"}
          </button>
        </Link> */}
        <button className="exit_btn" onClick={() => setShowLogoutModal(true)}>
          <img
            src="/assets/images/icon/exit.webp"
            className="exit_icon_img"
            alt="Exit"
          />
          {!collapsed && "Exit"}
        </button>
      </div>

      <Modal show={showLogoutModal} onHide={handleLogoutNo} centered>
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <p>Do you want to log out?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleLogoutNo}>
            No
          </Button>
          <Button variant="danger" onClick={handleLogoutYes}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default Dashboard_sidebar;
